module.exports = __webpack_public_path__ + "static/media/Logo@2x.d05ad620.png";